import { combineReducers } from "redux"
import phinMissingInformationExtractReducer, {
	PhinMissingInformationExtractState
} from "./missingInformation/reducer"

export interface PhinExtractsState {
	phinMissingInformation: PhinMissingInformationExtractState
}

const phinExtractsReducer = combineReducers({
	phinMissingInformation: phinMissingInformationExtractReducer
})

export default phinExtractsReducer
